// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutConfirmationDeliveryMethodStyles } from "@bg/App/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationDeliveryMethod";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import xScreen from "@bg/XDL/Utilities/xScreen";
import { css } from "styled-components";

onePageCheckoutConfirmationDeliveryMethodStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px 60px;
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};

onePageCheckoutConfirmationDeliveryMethodStyles.titleText = {
    variant: "h2",
    css: css`
        margin-bottom: 0;
        grid-column: 1 /3;
        ${xScreen("lte", "md")} {
            grid-column: initial;
        }
    `,
};

onePageCheckoutConfirmationDeliveryMethodStyles.headingAndTextStyles = {
    wrapper: {
        css: css`
            gap: 4px;
            flex-direction: row;
        `,
    },
    heading: {
        size: fontConfig.fontSize.regular,
        lineHeight: fontConfig.lineHeight.regular,
        transform: "capitalize",
        weight: fontConfig.weight.bold,
        css: css`
            white-space: nowrap;
        `,
    },
    text: {
        size: fontConfig.fontSize.regular,
        lineHeight: fontConfig.lineHeight.regular,
        css: css`
            white-space: nowrap;
        `,
    },
};

onePageCheckoutConfirmationDeliveryMethodStyles.notesHeadingAndTextStyles = {
    wrapper: {
        css: css`
            gap: 4px;
            flex-direction: row;
        `,
    },
    heading: {
        size: fontConfig.fontSize.regular,
        lineHeight: fontConfig.lineHeight.regular,
        transform: "capitalize",
        weight: fontConfig.weight.bold,
        css: css`
            white-space: nowrap;
        `,
    },
    text: {
        size: fontConfig.fontSize.regular,
        lineHeight: fontConfig.lineHeight.regular,
    },
};

onePageCheckoutConfirmationDeliveryMethodStyles.notes = {
    css: css`
        display: flex;
        flex: 1;
        flex-direction: column;
        gap: 8px;
        margin-top: 24px;
    `,
};
